import {
  Program, SavedProgram, RecommendProgram, KanbanColumn,
  EventItem, Feature, PlannerPlan, Milestone, ActivityItem,
} from './types';

// ─── 지원사업 공고 ───────────────────────────────────────────────────────────

const rawPrograms: Program[] = [
  {
    title: '2026년 창업성장기술개발사업 (디딤돌 R&D)',
    org: '중소벤처기업부', source: '중소벤처24', region: '전국', type: 'R&D',
    amount: '최대 1.2억원', dday: 'D-1', ddBg: '#ba1a1a', ddColor: '#fff',
    dotColor: '#ba1a1a', status: '접수중', statusLabel: '내일 마감', match: '98%',
    summary: '창업 7년 이내 기업의 시제품 개발·고도화를 지원하는 R&D 과제. 자부담 20%, 최대 12개월.',
    tags: ['R&D', '창업 7년이내'], deadline: '2026.06.19',
  },
  {
    title: '초기창업패키지 창업기업 모집',
    org: '창업진흥원', source: 'K-Startup', region: '전국', type: '사업화',
    amount: '최대 1억원', dday: 'D-3', ddBg: '#f97316', ddColor: '#fff',
    dotColor: '#f97316', status: '접수중', statusLabel: '3일 후 마감', match: '94%',
    summary: '창업 3년 이내 기업 대상 사업화 자금과 전담 멘토링·교육을 패키지로 지원.',
    tags: ['사업화', '3년이하'], deadline: '2026.06.21',
  },
  {
    title: '2026 수출바우처 지원사업',
    org: 'KOTRA', source: '기업마당', region: '전국', type: '수출',
    amount: '최대 5,000만원', dday: 'D-7', ddBg: '#fde68a', ddColor: '#854d0e',
    dotColor: '#eab308', status: '접수중', statusLabel: '7일 후 마감', match: '88%',
    summary: '해외 전시회·인증·마케팅 비용을 바우처 형태로 차등 지원. 매출 규모별 한도 상이.',
    tags: ['수출', '바우처'], deadline: '2026.06.25',
  },
  {
    title: '서울형 강소기업 성장지원',
    org: '서울경제진흥원(SBA)', source: 'SBA', region: '서울', type: '자금',
    amount: '최대 3,000만원', dday: 'D-14', ddBg: '#d6f0e2', ddColor: '#10663f',
    dotColor: '#1f8a5b', status: '접수중', statusLabel: '14일 후 마감', match: '81%',
    summary: '서울 소재 우수 중소기업의 청년 채용·근무환경 개선 비용을 지원.',
    tags: ['자금', '서울'], deadline: '2026.07.02',
  },
  {
    title: 'AI 바우처 지원사업',
    org: '정보통신산업진흥원(NIPA)', source: '기업마당', region: '전국', type: '사업화',
    amount: '최대 3억원', dday: 'D-21', ddBg: '#d6f0e2', ddColor: '#10663f',
    dotColor: '#1f8a5b', status: '접수중', statusLabel: '21일 후 마감', match: '76%',
    summary: 'AI 솔루션 도입을 희망하는 중소·중견기업에 공급기업 바우처를 지원.',
    tags: ['AI', '바우처'], deadline: '2026.07.09',
  },
  {
    title: '재도전 성공패키지',
    org: '창업진흥원', source: 'K-Startup', region: '전국', type: '사업화',
    amount: '최대 6,000만원', dday: '마감', ddBg: '#e5e5ea', ddColor: '#737685',
    dotColor: '#ba1a1a', status: '마감', statusLabel: '2026.06.10 마감', match: '—',
    summary: '재창업자 대상 사업화 자금·교육·멘토링 지원. 이번 회차 접수가 종료되었습니다.',
    tags: ['재창업'], deadline: '2026.06.10', closed: true,
  },
];

export const programs: Program[] = rawPrograms.map(p => ({
  ...p,
  matchBg: p.closed ? '#e5e5ea' : '#003d9b',
  matchColor: p.closed ? '#737685' : '#fff',
  cardOpacity: p.closed ? '.62' : '1',
  statusColor: p.closed ? '#737685' : p.dotColor,
  btnLabel: p.closed ? '마감됨' : '상세 보기',
}));

// ─── 저장된 공고 ──────────────────────────────────────────────────────────────

export const savedPrograms: SavedProgram[] = [
  { ...programs[0], savedAt: '3일 전 저장', alert: true, alertText: '내일 마감 — 아직 신청 전이에요', alertBg: '#fff5f5', alertBorder: '#ffdad6', alertColor: '#ba1a1a', alertIcon: 'notifications_active', inTracker: true, trackBg: '#d6f0e2', trackColor: '#10663f', trackIcon: 'check', trackLabel: '트래킹 중' },
  { ...programs[1], savedAt: '5일 전 저장', alert: true, alertText: '3일 후 마감 — 준비 중 단계예요', alertBg: '#fff7ed', alertBorder: '#fed7aa', alertColor: '#9a3412', alertIcon: 'timer', inTracker: true, trackBg: '#d6f0e2', trackColor: '#10663f', trackIcon: 'check', trackLabel: '트래킹 중' },
  { ...programs[2], savedAt: '1주 전 저장', alert: false, inTracker: true, trackBg: '#d6f0e2', trackColor: '#10663f', trackIcon: 'check', trackLabel: '트래킹 중' },
  { ...programs[3], savedAt: '1주 전 저장', alert: false, inTracker: false, trackBg: '#e9edff', trackColor: '#003d9b', trackIcon: 'add_task', trackLabel: '트래킹 추가' },
  { ...programs[4], savedAt: '2주 전 저장', alert: false, inTracker: false, trackBg: '#e9edff', trackColor: '#003d9b', trackIcon: 'add_task', trackLabel: '트래킹 추가' },
];

// ─── 맞춤 추천 ────────────────────────────────────────────────────────────────

export const recommendPrograms: RecommendProgram[] = [
  { ...programs[0], reason: ['업종 IT·SW 일치', '창업 7년 이내 충족', '벤처기업 가점'], rank: 1 },
  { ...programs[1], reason: ['업종 일치', '창업 3년차 적합', '전담 멘토링 제공'], rank: 2 },
  { ...programs[2], reason: ['관심분야 수출 일치', '매출 규모 적합'], rank: 3 },
  { ...programs[4], reason: ['AI 분야 일치', '바우처 형태 선호'], rank: 4 },
  { ...programs[3], reason: ['서울 소재 일치', '채용 계획 보유'], rank: 5 },
];

// ─── 행사·이벤트 ──────────────────────────────────────────────────────────────

const evType: Record<string, { bg: string; color: string }> = {
  'IR·투자':  { bg: '#e9edff', color: '#003d9b' },
  '설명회':   { bg: '#d6f0e2', color: '#10663f' },
  '교육':     { bg: '#50dcff', color: '#005f71' },
  '박람회':   { bg: '#fde68a', color: '#854d0e' },
  '공모전':   { bg: '#e5deff', color: '#4633a0' },
  '입주모집': { bg: '#ffdad6', color: '#93000a' },
};

function ev(title: string, type: string, date: string, loc: string, org: string, dday: string, day: number): EventItem {
  return { title, type, date, loc, org, dday, day, typeBg: evType[type].bg, typeColor: evType[type].color };
}

export const events: EventItem[] = [
  ev('2026 K-Global 스타트업 데모데이',   'IR·투자',  '2026.07.03 (목)', '서울 강남 코엑스',     '창업진흥원·SBA', 'D-15', 3),
  ev('정부지원사업 통합 온라인 설명회',   '설명회',   '2026.06.27 (토)', '온라인 생중계',         '중소벤처24',     'D-9',  27),
  ev('예비창업자 사업계획서 작성 워크숍', '교육',     '2026.06.30 (화)', '판교 스타트업캠퍼스',  'K-Startup',      'D-12', 30),
  ev('KOTRA 글로벌 비즈니스 위크 수출상담회','박람회', '2026.07.10 (금)', '코엑스 C홀',           'KOTRA',          'D-22', 10),
  ev('제8회 스타트업 IR 피칭 공모전',     '공모전',   '2026.07.18 (토)', '서울창업허브 공덕',    'SBA',            'D-30', 18),
  ev('성수 코워킹 창업보육센터 입주기업 모집','입주모집','2026.07.25 (금)','성수 코워킹스페이스', '서울창업허브',   'D-37', 25),
];

// ─── 캘린더 셀 ───────────────────────────────────────────────────────────────

const calEvents: Record<number, { c: string }> = {
  3:  { c: '#003d9b' },
  10: { c: '#eab308' },
  18: { c: '#4633a0' },
  25: { c: '#93000a' },
};

export function buildCalCells() {
  const cells = [];
  for (let i = 0; i < 3; i++) cells.push({ day: '', dot: 'transparent', cellBg: 'transparent', cellBorder: 'none', numColor: '#c3c6d6' });
  for (let d = 1; d <= 31; d++) {
    const e = calEvents[d];
    cells.push({ day: String(d), dot: e ? e.c : 'transparent', cellBg: e ? '#eef3ff' : 'transparent', cellBorder: e ? `1.5px solid ${e.c}` : '1px solid #f0f2fa', numColor: e ? '#003d9b' : '#434654' });
  }
  while (cells.length < 35) cells.push({ day: '', dot: 'transparent', cellBg: 'transparent', cellBorder: 'none', numColor: '#c3c6d6' });
  return cells;
}

// ─── 기능 소개 ────────────────────────────────────────────────────────────────

export const features: Feature[] = [
  { icon: 'travel_explore', title: '통합 검색·필터', desc: '수십 개 포털의 공고를 한 곳에서. 업종·지역·금액·마감일로 정밀 필터링.' },
  { icon: 'auto_awesome',  title: 'AI 3줄 요약·자가진단', desc: '긴 공고문을 핵심만. 자격 조건을 체크하면 지원 가능 여부를 즉시 판정.' },
  { icon: 'forum',         title: '공고문 챗봇', desc: '원문 근거 기반으로 답변. "나 지원 가능해?"를 바로 물어보세요.' },
  { icon: 'view_kanban',   title: '트래킹·마감 관리', desc: '칸반 보드로 진행 상황을, 역산 플래너로 마감 일정을 자동 관리.' },
];

// ─── 칸반 보드 ───────────────────────────────────────────────────────────────

export function buildInitialBoard(): KanbanColumn[] {
  return [
    { name: '관심', accent: '#737685', cards: [
      { id: 'c1', title: 'AI 바우처 지원사업', dday: 'D-21', ddBg: '#d6f0e2', ddColor: '#10663f', tag: '사업화', amount: '최대 3억원', memo: 'NIPA 공급기업 풀 확인 필요' },
      { id: 'c2', title: '서울형 강소기업 성장지원', dday: 'D-14', ddBg: '#d6f0e2', ddColor: '#10663f', tag: '자금', amount: '최대 3천만원', memo: '' },
      { id: 'c3', title: '데이터바우처 지원사업', dday: 'D-18', ddBg: '#d6f0e2', ddColor: '#10663f', tag: '바우처', amount: '최대 7천만원', memo: '' },
    ]},
    { name: '준비 중', accent: '#003d9b', cards: [
      { id: 'c4', title: '초기창업패키지', dday: 'D-3', ddBg: '#f97316', ddColor: '#fff', urgent: true, tag: '사업화', amount: '최대 1억원', memo: '사업계획서 초안 작성 중 (60%)' },
      { id: 'c5', title: '창업성장기술개발 R&D', dday: 'D-1', ddBg: '#ba1a1a', ddColor: '#fff', urgent: true, tag: 'R&D', amount: '최대 1.2억원', memo: '예산 산정표 최종 검토' },
    ]},
    { name: '제출 완료', accent: '#00687b', cards: [
      { id: 'c6', title: '2026 수출바우처', dday: '제출됨', ddBg: '#e9edff', ddColor: '#003d9b', tag: '수출', amount: '최대 5천만원', memo: '06.14 온라인 제출 완료' },
    ]},
    { name: '결과 대기', accent: '#854d0e', cards: [
      { id: 'c7', title: '스마트공장 구축지원', dday: '발표 07.05', ddBg: '#fde68a', ddColor: '#854d0e', tag: '자금', amount: '최대 5천만원', memo: '현장평가 완료, 결과 대기' },
    ]},
    { name: '선정 / 탈락', accent: '#1f8a5b', cards: [
      { id: 'c8', title: '청년창업사관학교 14기', result: '선정', resBg: '#d6f0e2', resColor: '#10663f', dday: '', ddBg: '', ddColor: '', tag: '사업화', amount: '최대 1억원', memo: '협약 체결 예정' },
      { id: 'c9', title: '디딤돌 창업과제 (전기)', result: '탈락', resBg: '#ffdad6', resColor: '#93000a', dday: '', ddBg: '', ddColor: '', tag: 'R&D', amount: '최대 5천만원', memo: '차기 회차 재도전' },
    ]},
  ];
}

// ─── 플래너 ──────────────────────────────────────────────────────────────────

export function styleMilestones(list: Milestone[]): Milestone[] {
  return list.map(m => {
    const o = { ...m };
    if (o.finish)        { o.dotBg='#051a3e'; o.dotBorder='none'; o.icon='flag'; o.iconColor='#fff'; o.statusLabel='마감'; o.statusColor='#ba1a1a'; o.labelWeight=700; o.labelColor='#051a3e'; }
    else if (o.done)     { o.dotBg='#1f8a5b'; o.dotBorder='none'; o.icon='check'; o.iconColor='#fff'; o.statusLabel='완료'; o.statusColor='#1f8a5b'; o.labelWeight=500; o.labelColor='#737685'; }
    else if (o.current)  { o.dotBg='#fff'; o.dotBorder='3px solid #003d9b'; o.icon=''; o.iconColor='#003d9b'; o.statusLabel='진행 중'; o.statusColor='#003d9b'; o.labelWeight=700; o.labelColor='#051a3e'; }
    else                 { o.dotBg='#fff'; o.dotBorder='2px solid #c3c6d6'; o.icon=''; o.iconColor='#c3c6d6'; o.statusLabel='예정'; o.statusColor='#737685'; o.labelWeight=500; o.labelColor='#434654'; }
    return o;
  });
}

export const plannerPlans: PlannerPlan[] = [
  {
    id: 'p_seed', title: '초기창업패키지', type: '사업화', org: '창업진흥원 · K-Startup',
    deadline: '2026.07.21', dday: 'D-33', ddColor: '#003d9b', urgent: false,
    milestones: styleMilestones([
      { label: '필요 서류 목록 확인',        dday: 'D-33', date: '오늘 (06.18)', done: true },
      { label: '사업계획서 초안 작성',        dday: 'D-28', date: '06.23', done: true },
      { label: '기업 현황·재무 서류 준비',   dday: 'D-21', date: '06.30', current: true },
      { label: '사업계획서 1차 검토',         dday: 'D-14', date: '07.07' },
      { label: '최종본 완성 및 첨부서류 정리', dday: 'D-7', date: '07.14' },
      { label: '제출 전 최종 점검',           dday: 'D-3', date: '07.18' },
      { label: '온라인 제출',                  dday: 'D-1', date: '07.20' },
      { label: '접수 마감',                    dday: 'D-0', date: '07.21', finish: true },
    ]),
  },
  {
    id: 'p_rnd', title: '창업성장기술개발 R&D (디딤돌)', type: 'R&D', org: '중소벤처기업부 · 중소벤처24',
    deadline: '2026.06.19', dday: 'D-1', ddColor: '#ba1a1a', urgent: true,
    milestones: styleMilestones([
      { label: '사업계획서(RFP 양식) 작성',       dday: 'D-10', date: '06.09', done: true },
      { label: '연구개발 인력·연구소 증빙 준비',  dday: 'D-7',  date: '06.12', done: true },
      { label: '예산 산정표 작성',                  dday: 'D-4',  date: '06.15', done: true },
      { label: '예산 산정표 최종 검토',             dday: 'D-1',  date: '06.18', current: true },
      { label: '온라인(SMTECH) 제출',               dday: 'D-1',  date: '06.19' },
      { label: '접수 마감',                          dday: 'D-0',  date: '06.19', finish: true },
    ]),
  },
  {
    id: 'p_export', title: '2026 수출바우처 지원사업', type: '수출', org: 'KOTRA · 기업마당',
    deadline: '2026.06.25', dday: 'D-7', ddColor: '#f97316', urgent: false,
    milestones: styleMilestones([
      { label: '수행기관 견적·계획 수집',      dday: 'D-7', date: '오늘 (06.18)', current: true },
      { label: '전년도 수출실적 증빙 준비',    dday: 'D-5', date: '06.20' },
      { label: '사업 신청서 작성',              dday: 'D-3', date: '06.22' },
      { label: '온라인 제출',                   dday: 'D-1', date: '06.24' },
      { label: '접수 마감',                     dday: 'D-0', date: '06.25', finish: true },
    ]),
  },
].map(p => {
  const done = p.milestones.filter(m => m.done).length;
  const total = p.milestones.length;
  return {
    ...p,
    doneCount: done,
    totalCount: total,
    progressLabel: `${done} / ${total} 완료`,
    progressPct: `${Math.round(done / total * 100)}%`,
  };
});

// ─── 최근 활동 ────────────────────────────────────────────────────────────────

export const activity: ActivityItem[] = [
  { tag: '지원 선정',     dot: '#1f8a5b', tagBg: '#d6f0e2', tagColor: '#10663f', time: '2시간 전', title: '청년창업사관학교 14기', desc: '서류·발표 평가를 통과해 최종 선정되었습니다. 담당 매니저가 48시간 내 협약 절차를 안내합니다.', action: '' },
  { tag: '서류 보완 요청', dot: '#f97316', tagBg: '#ffedd5', tagColor: '#9a3412', time: '어제', title: '스마트공장 구축지원', desc: '현장평가단이 설비 견적서 보완을 요청했습니다. 06.20까지 추가 서류를 업로드해 주세요.', action: '문서 업로드' },
  { tag: '신규 공고',      dot: '#003d9b', tagBg: '#e9edff', tagColor: '#003d9b', time: '2026.06.16', title: 'AI 바우처 지원사업 공고 등록', desc: '기업 프로필과 92% 일치하는 신규 공고가 등록되었습니다. 자가진단을 진행해 보세요.', action: '' },
];
